import React from 'react';
import PropTypes from 'prop-types';

import ConfirmationCard from '../../components/Shared/ConfirmationCardMultiActionsCard';
import TitleComponent from '../../components/Shared/TitleMultiActionsCard';
import { TransitionContainerNoExit } from '../../components/Transition/TranstionContainer';

export const OpinionSuccessMultiActionCard = props => (
    <TransitionContainerNoExit>
        <ConfirmationCard
            thankYouText={props.thankYouText}
            titleComponent={
                <TitleComponent
                    thankYouTitle={props.thankYouTitle}
                />
            }
            {...props}
        />
    </TransitionContainerNoExit>
);

OpinionSuccessMultiActionCard.propTypes = {
    thankYouText: PropTypes.string.isRequired,
    thankYouTitle: PropTypes.string,
};
